// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --store-coles-color: #d71920;
  --store-coles-strong: #9f171b;
  --store-coles-bg: #fde8ea;
  --store-coles-row-bg: #fffafa;
  --store-coles-chart-bg: rgba(215, 25, 32, 0.16);

  --store-woolworths-color: #138540;
  --store-woolworths-strong: #176d35;
  --store-woolworths-bg: #e5f6df;
  --store-woolworths-row-bg: #f8fff9;
  --store-woolworths-chart-bg: rgba(19, 133, 64, 0.14);

  --store-aldi-color: #004b93;
  --store-aldi-strong: #0f4c81;
  --store-aldi-bg: #e5f0ff;
  --store-aldi-row-bg: #f8fbff;
  --store-aldi-chart-bg: rgba(0, 75, 147, 0.14);

  --store-iga-color: #a50034;
  --store-iga-strong: #7f0028;
  --store-iga-bg: #ffe8ee;
  --store-iga-row-bg: #fff7f9;
  --store-iga-chart-bg: rgba(165, 0, 52, 0.14);

  --store-amazon-color: #111827;
  --store-amazon-strong: #111827;
  --store-amazon-bg: #fff4df;
  --store-amazon-row-bg: #fffbf2;
  --store-amazon-chart-bg: rgba(17, 24, 39, 0.12);
}
`, "",{"version":3,"sources":["webpack://./src/styles/StoreBranding.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,+CAA+C;;EAE/C,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;EAC9B,kCAAkC;EAClC,oDAAoD;;EAEpD,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,4BAA4B;EAC5B,6CAA6C;;EAE7C,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,4CAA4C;;EAE5C,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,+CAA+C;AACjD","sourcesContent":[":root {\n  --store-coles-color: #d71920;\n  --store-coles-strong: #9f171b;\n  --store-coles-bg: #fde8ea;\n  --store-coles-row-bg: #fffafa;\n  --store-coles-chart-bg: rgba(215, 25, 32, 0.16);\n\n  --store-woolworths-color: #138540;\n  --store-woolworths-strong: #176d35;\n  --store-woolworths-bg: #e5f6df;\n  --store-woolworths-row-bg: #f8fff9;\n  --store-woolworths-chart-bg: rgba(19, 133, 64, 0.14);\n\n  --store-aldi-color: #004b93;\n  --store-aldi-strong: #0f4c81;\n  --store-aldi-bg: #e5f0ff;\n  --store-aldi-row-bg: #f8fbff;\n  --store-aldi-chart-bg: rgba(0, 75, 147, 0.14);\n\n  --store-iga-color: #a50034;\n  --store-iga-strong: #7f0028;\n  --store-iga-bg: #ffe8ee;\n  --store-iga-row-bg: #fff7f9;\n  --store-iga-chart-bg: rgba(165, 0, 52, 0.14);\n\n  --store-amazon-color: #111827;\n  --store-amazon-strong: #111827;\n  --store-amazon-bg: #fff4df;\n  --store-amazon-row-bg: #fffbf2;\n  --store-amazon-chart-bg: rgba(17, 24, 39, 0.12);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
